export function youTubeUrl(id) {
    return `https://www.youtube.com/watch?v=${id}`;
}


// WEBPACK FOOTER //
// ./src/helpers.js